import api from './index';
//
let exports = {};
// =============================== 门禁控制器 ===============================
// 零售门禁控制器分页列表
exports.getShopDevcDoorCtrlerPageList = function (postData, callback) {
    api.post('/retailer/door/ctrl/page/list/get')
    .data(postData)
    .done(callback)
    .go();
};
// 零售门禁控制器详情
exports.getShopDevcDoorCtrlerInfo = function (params, callback) {
    api.get('/retailer/door/ctrl/info/get')
    .params(params)
    .done(callback)
    .go();
};
// 零售门禁控制器-新增
exports.saveShopDevcDoorCtrler = function (postData, callback) {
    api.post('/retailer/door/ctrl/save/do')
    .data(postData)
    .done(callback)
    .go();
};
// 零售门禁控制器-编辑
exports.updateShopDevcDoorCtrlerInfo = function (postData, callback) {
    api.post('/retailer/door/ctrl/update/info/do')
    .data(postData)
    .done(callback)
    .go();
};
// 零售门禁控制器-就绪
exports.updateShopDevcDoorCtrlerForReady = function (postData, callback) {
    api.post('/retailer/door/ctrl/update/ready/do')
    .data(postData)
    .done(callback)
    .go();
};
// 零售门禁控制器-作废
exports.updateShopDevcDoorCtrlerForInvalid = function (postData, callback) {
    api.post('/retailer/door/ctrl/update/invalid/do')
    .data(postData)
    .done(callback)
    .go();
};
// 零售门禁控制器-删除
exports.deleteShopDevcDoorCtrler = function (postData, callback) {
    api.post('/retailer/door/ctrl/delete/do')
    .data(postData)
    .done(callback)
    .go();
};

// =============================== 门禁控制门 ===============================

// 控制门-分页分页列表
exports.getShopDevcDoorPageList = function (postData, callback) {
    api.post('/retailer/door/shop/devc/door/page/list/get')
    .data(postData)
    .done(callback)
    .go();
};
// 门禁-详情
exports.getShopDevcDoorInfo = function (params, callback) {
    api.get('/retailer/door/shop/devc/door/info/get')
    .params(params)
    .done(callback)
    .go();
};
// 新增-门禁
exports.saveShopDevcDoor = function (postData, callback) {
    api.post('/retailer/door/shop/devc/door/save/do')
    .data(postData)
    .done(callback)
    .go();
};
// 编辑-门禁
exports.updateShopDevcDoor = function (postData, callback) {
    api.post('/retailer/door/shop/devc/door/update/do')
    .data(postData)
    .done(callback)
    .go();
};
// 删除-门禁
exports.deleteShopDevcDoor = function (postData, callback) {
    api.post('/retailer/door/shop/devc/door/delete/do')
    .data(postData)
    .done(callback)
    .go();
};
// 同步门禁状态
exports.doShopDevcDoorStateSync = function (postData, callback) {
    api.post('/retailer/door/shop/devc/door/state/sync/do')
    .data(postData)
    .done(callback)
    .go();
};

// =============================== 门禁-权限 ===============================

// 权限分页列表
exports.getRetailerDoorCtrlPageList = function (postData, callback) {
    api.post('/retailer/door/staff/ctrl/page/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// 权限列表
exports.getRetailerDoorCtrlList = function (params, callback) {
    api.post('/retailer/door/staff/ctrl/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 权限列表-人
exports.getRetailerDoorCtrlListByStaffId = function (params, callback) {
    api.get('/retailer/door/staff/ctrl/list/get/by/staffId')
    .params(params)
    .done(callback)
    .go();
};

// 权限信息
exports.getRetailerDoorCtrlInfo = function (postData, callback) {
    api.get('/retailer/door/staff/ctrl/info/get')
    .params(postData)
    .done(callback)
    .go();
};

// 权限-新增
exports.saveRetailerDoorCtrlInfo = function (postData, callback) {
    api.post('/retailer/door/staff/ctrl/save/do')
    .data(postData)
    .done(callback)
    .go();
};

// 权限-编辑
exports.updateRetailerDoorCtrlInfo = function (postData, callback) {
    api.post('/retailer/door/staff/ctrl/update/do')
    .data(postData)
    .done(callback)
    .go();
};

// 权限-删除
exports.deleteRetailerDoorCtrlInfo = function (postData, callback) {
    api.post('/retailer/door/staff/ctrl/delete/do')
    .data(postData)
    .done(callback)
    .go();
};

// =============================== 门禁日志 ===============================

// 零售商门禁日志分页列表
exports.getRetailerDoorCtrlLogPageList = function (postData, callback) {
    api.post('/retailer/door/ctrl/log/page/list/get')
    .data(postData)
    .done(callback)
    .go();
};
// 提交零售商门禁日志查询条件，返回下载url
exports.getRetailerDoorCtrlLogExportUuid = function (postData, callback) {
    api.post('/retailer/door/ctrl/log/export/uuid/get')
    .data(postData)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/doorCtrl.js
// module id = 137
// module chunks = 0